import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { DataGrid } from "@material-ui/data-grid";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Moment from "react-moment";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import moment from "moment";

import MyButton from "./MyButton";
import SuKienXuLyDialog from "./SuKienXuLyDialog";
import SuKienXuLyDiDialog from "./SuKienXuLyDiDialog";
import SuKienPhuongTienDialog from "./SuKienPhuongTienDialog";
import SuKienKetThucDialog from "./SuKienKetThucDialog";

const server = require("../lib/server.js");
const myLib = require("../lib/MyLib.js");

const styles = {
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content",
    heigh: "fit-content",
  },
  formControl: {
    marginTop: 2,
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: 1,
  },
  paper: {},
  textField: {
    marginLeft: 1,
    marginRight: 1,
    width: 250,
  },
};
const columns = [
  { field: "id", headerName: "STT", width: 70 },
  {
    field: "HanhDong",
    headerName: "Nhật ký",
    width: 230,
    valueGetter: (params) => {
      let hanhdong = params.getValue("HanhDong");
      return hanhdong === 1
        ? "Thông tin ban đầu"
        : hanhdong === 2
        ? "Xử lý"
        : hanhdong === 3
        ? "Kết thúc"
        : "";
    },
  },
  {
    field: "ThoiGian",
    headerName: "Thời gian",
    width: 130,
    renderCell: (params) => (
      <Moment format="DD-MM-yyyy">{params.getValue("ThoiGian")}</Moment>
    ),
  },
  { field: "TenCoQuan", headerName: "Trung tâm", width: 230 },
];

class SuKienChiTietDialog extends React.Component {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
    this.handleAction = this.handleAction.bind(this);
    this.state = {
      open: props.visible,
      fullWidth: true,
      maxWidth: "sm",
      sukien: {
        nguontin: "HCM RADIO",
      }, //thong tin ve su kien
      dataRows: [],
      xulyden_dialog_show: false,
      xulydi_dialog_show: false,
      phuongtien_dialog_show: false,
      ketthuc_dialog_show: false,
    };
  }
  componentDidMount() {
    server
      .query("sukien/getchitiet?mask=1")
      .then((response) => this.setState({ dataRows: response }))
      .catch((error) => console.log(error));
  }
  render() {
    return <div>Hello</div>;
  }
  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
    if (this.props.onClose) {
      this.props.onClose();
    }
  };
  handleAction = (action) => {
    if (action === "xulyden") {
      this.setState({ xulyden_dialog_show: true });
    }
    if (action === "xulydi") {
      this.setState({ xulydi_dialog_show: true });
    }
    if (action === "phuongtien") {
      this.setState({ phuongtien_dialog_show: true });
    }
    if (action === "ketthuc") {
      this.setState({ ketthuc_dialog_show: true });
    }
  };
  static getDerivedStateFromProps(props, state) {
    return { ...state };
  }
  render() {
    return (
      <React.Fragment>
        <Dialog
          fullWidth={true}
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="max-width-dialog-title"
          maxWidth="lg"
        >
          <DialogTitle id="max-width-dialog-title">
            Nhật ký xử lý sự vụ
          </DialogTitle>
          <DialogContent>
            <form style={styles.form} noValidate autoComplete="off">
              <Grid container spacing={3}>
                <Grid item xs={4}>
                  <TextField id="txtTentau" label="Tên sự vụ:" />
                </Grid>
                <Grid item xs={4}>
                  <TextField id="txtTentau" label="Số hồ sơ:" />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    id="datetime-local"
                    label="Thời gian(HN):"
                    type="datetime-local"
                    defaultValue="2017-05-24T10:30"
                    format="DD-MM-YYYY"
                    style={styles.textField}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <div style={{ height: 400, width: "100%" }}>
                  <DataGrid
                    rows={this.state.dataRows}
                    columns={columns}
                    id="MaSK"
                    hideFooterPagination={true}
                  />
                </div>
              </Grid>
            </form>
          </DialogContent>
          <DialogActions>
            <MyButton
              onClick={() => {
                this.handleAction("xulyden");
              }}
              color="primary"
              text="Thông tin đến"
            />
            <MyButton
              onClick={() => {
                this.handleAction("xulydi");
              }}
              color="primary"
              text="Thông tin đi"
            />
            <MyButton
              onClick={() => {
                this.handleAction("phuongtien");
              }}
              color="primary"
              text="Điều động"
            />
            <MyButton
              onClick={() => {
                this.handleAction("ketthuc");
              }}
              color="primary"
              text="Kết thúc"
            />
            <MyButton onClick={this.handleClose} color="primary" text="Sửa" />
            <MyButton onClick={this.handleClose} color="primary" text="Xóa" />
            <MyButton onClick={this.handleClose} color="primary" text="Thoát" />
          </DialogActions>
        </Dialog>
        {this.state.xulyden_dialog_show ? (
          <SuKienXuLyDialog
            visible={true}
            onClose={() => {
              this.setState({ xulyden_dialog_show: false });
            }}
          />
        ) : null}
        {this.state.xulydi_dialog_show ? (
          <SuKienXuLyDiDialog
            visible={true}
            onClose={() => {
              this.setState({ xulydi_dialog_show: false });
            }}
          />
        ) : null}
        {this.state.phuongtien_dialog_show ? (
          <SuKienPhuongTienDialog
            visible={true}
            onClose={() => {
              this.setState({ phuongtien_dialog_show: false });
            }}
          />
        ) : null}
        {this.state.ketthuc_dialog_show ? (
          <SuKienKetThucDialog
            visible={true}
            onClose={() => {
              this.setState({ ketthuc_dialog_show: false });
            }}
          />
        ) : null}
      </React.Fragment>
    );
  }
}
export default SuKienChiTietDialog;
